import "@mdi/font/css/materialdesignicons.css";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
// import apiUrls
// import apiUrls from '@/utils/apiUrls'
import auth from "@websanova/vue-auth";
import httpAxios from "@websanova/vue-auth/drivers/http/axios.1.x.js";
import routerVueRouter from "@websanova/vue-auth/drivers/router/vue-router.2.x.js";
import "animate.css/animate.css";
import axios from "axios";
import "codemirror/lib/codemirror.css";
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import VueAxios from "vue-axios";
import VueCodemirror from "vue-codemirror";
import VueIntercom from "@mathieustan/vue-intercom";
import VueSignaturePad from "vue-signature-pad";
import { sync } from "vuex-router-sync";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { isProduction } from '@/utils/environments.js'

Vue.use(VueCodemirror);

Vue.component("apexchart", VueApexCharts);

if (isProduction()) {
  Vue.use(VueIntercom, { appId: "bl5c5dn7" });
}

Vue.use(VueAxios, axios);
Vue.use(VueSignaturePad);

sync(store, router);

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracingOptions: {
    trackComponents: true,
  },
  environment: process.env.VUE_APP_ENV,
  release: process.env.VUE_APP_SENTRY_RELEASE,
  tracesSampleRate: 1.0,
});

Vue.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

Vue.prototype.$sentry = Sentry;

Vue.use(auth, {
  auth: {
    request(req, token) {
      this.http.setHeaders.call(this, req, {
        Authorization: "Bearer " + token,
      });
    },
    response(res) {
      return (res.data || {}).token;
    },
  },
  http: httpAxios,
  router: routerVueRouter,
  rolesKey: "role",
  logoutData: {
    redirect: '/login',
    makeRequest: false

  },
  fetchData: {
    enabled: true,
    method: "GET",
    url: "/current_user",
  },
  parseUserData: function(data) {
    return data || {};
  },
});

Vue.prototype.$message = {
  success: (text) => {
    store.dispatch("message", { type: "success", text: text });
  },

  error: (text) => {
    store.dispatch("message", { type: "error", text: text });
  },

  errorFromServer: (e) => {
    store.dispatch("message", { type: "error", text: e.response.data.Error });
  },

  info: (text) => {
    store.dispatch("message", { type: "info", text: text });
  },

  warning: (text) => {
    store.dispatch("message", { type: "warning", text: text });
  },
};

Vue.config.productionTip = false;

Vue.filter('gbp', function (value) {
  const thousandSeparated = value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  return `£${thousandSeparated}`
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
